export var ID_APP_AUTHENTICATED = -2;
export var ID_USER_AUTHENTICATED = -2;
export var ID_USER_NONE = -1;
var AbstractAuthentication = (function () {
    function AbstractAuthentication(idApplication, idUser) {
        if (idUser === void 0) { idUser = ID_USER_NONE; }
        if (!Number.isInteger(idApplication)) {
            throw new TypeError("idApplication is not an integer number. Given: " + idApplication + " (" + typeof idApplication + ")");
        }
        this.idApplication = idApplication;
        if (!Number.isInteger(idUser)) {
            throw new TypeError("idUser is not an integer number. Given: " + idUser + " (" + typeof idUser + ")");
        }
        this.idUser = idUser;
    }
    AbstractAuthentication.peerInfoFromMessage = function (msg) {
        if (msg && msg.Message === 'Foundation::DisconnectionMessage') {
            var disconnectMessage = msg;
            throw new Error("Disconnection Message: " + disconnectMessage.details);
        }
        if (msg && (msg.Message === 'Foundation::AuthenticationByTokenResponse' || msg.Message === 'Foundation::ConfigurationResponse')) {
            var message = msg;
            return {
                uuid: message.server_info.uuid,
                description: message.server_info.description,
                software: message.server_info.software,
                os: message.server_info.os,
                maximumIdleInterval: parseInt(message.maximum_idle_interval),
                maximumReceivableMessageSize: message.maximum_receivable_message_size
            };
        }
        throw new Error('Could not extract server_info from unknown message type.');
    };
    return AbstractAuthentication;
}());
export { AbstractAuthentication };
//# sourceMappingURL=AbstractAuthentication.js.map